/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import Axios from 'axios';
import { useContext, useEffect, useState } from 'react';
import { Accordion, Button, Card, Col, Row, Table } from 'react-bootstrap';
import { Redirect, useHistory } from 'react-router-dom';
import InputControlAsync from '../../../components/inputs/InputControlAsync';
import Layout from '../../../components/layout';
import DashboardContext from '../../../Context';
import FormUser from '../userManagement/FormUser';
import AddresCoustoumer from './AddresCoustoumer';
import FinanceCustomer from './finance/FinanceCustomer';
import OrderCustomer from './OrderCustomer';
import BlacklistCustomer from './BlacklistCustomer';
import FavoritelistCustomer from './FavoritelistCustomer';
import JobDispatchCustomer from './JobDispatchCustomer';
import CanceledOrders from './CanceledOrders';
import Introducers from 'pages/forces/worker/introducers';
import WorkerMessages from 'pages/forces/worker/workerMessages';

export default function Coustoumer({ match }) {
  const {
    authentication,
    urldashboard,
    handeldmicro,
    islogin,
    handelworkername,
    handelAdd,
    SohwaddFrom,
    handelEdit,
    handelloding,
    handelerrors,
    HandlechangeNumber,
  } = useContext(DashboardContext);

  const [idAccordion, setIdAccordion] = useState();
  const [dataFech, setDataFech] = useState({});
  const [navitem, setNavitem] = useState('اطلاعات شخصی');

  const history = useHistory();

  const dataFeching = async () => {
    try {
      const res = await Axios.get(
        `${urldashboard}/customer/getinfo/${match.params.id}`,
        {
          headers: {
            Authorization: authentication,
            'Content-Type': 'application/json',
          },
        }
      );
      const data = await res.data.data;
      setDataFech(data);
      handelworkername(data.fullName);
    } catch (error) {
      handelerrors(error);
    }
  };

  useEffect(() => {
    dataFeching();
    sessionStorage.setItem('customerid', JSON.stringify(match.params.id));
    return () => {};
  }, [history, match]);

  const handlechangeUserMobile = (data) => {
    handelAdd(true);
    HandlechangeNumber(data);
    handelloding();
  };

  const handelnavLink = (id) => {
    switch (id) {
      case 'اطلاعات شخصی':
        setNavitem('اطلاعات شخصی');
        break;
      case 'امور مالی':
        setNavitem('امور مالی');
        break;
      case 'سفارشات':
        setNavitem('سفارشات');
        break;
      case 'نیروهای لیست سیاه':
        setNavitem('نیروهای لیست سیاه');
        break;
      case 'نیروهای مورد علاقه':
        setNavitem('نیروهای مورد علاقه');
        break;
      case 'سفارشات پخش کار خودکار':
        setNavitem('سفارشات پخش کار خودکار');
        break;
      case 'سفارشات لغو شده':
        setNavitem('سفارشات لغو شده');
        break;
      case 'نظرسنجی':
        setNavitem('نظرسنجی');
        break;
      case 'پیام‌ها':
        setNavitem('پیام‌ها');
        break;
      case 'معرف‌ها':
        setNavitem('معرف‌ها');
        break;
      default:
        break;
    }
    defaultAcionts();
  };

  const handelAccordion = (id) => {
    setIdAccordion(id);
    defaultAcionts();
  };

  const defaultAcionts = () => {
    handeldmicro(false);
    sessionStorage.setItem('startpageProps', JSON.stringify(1));
    sessionStorage.setItem('serchProps', JSON.stringify(''));
    sessionStorage.setItem('pageSizeProps', JSON.stringify(10));
    sessionStorage.setItem('PaginationProps', JSON.stringify([]));
    sessionStorage.setItem('startpage', JSON.stringify(1));
    sessionStorage.setItem('serch', JSON.stringify(''));
    sessionStorage.setItem('pageSize', JSON.stringify(10));
    sessionStorage.setItem('Pagination', JSON.stringify([]));
    handelEdit('');
  };

  const handelCloseEdit = () => {
    handelAdd(false);
    handelEdit('');
    handelloding(false);
  };

  const handelEditbtn = (id) => {
    handelAdd(true);
    handelEdit(id);
    handelloding(true);
  };

  const handelValue = (name, value) => {
    if (value) {
      history.push(`/Customer/${value}`);
      window.location.reload();
    }
  };

  return (
    <>
      {islogin ? (
        <Layout>
          <Row>
            <Col>
              <InputControlAsync
                url='/userManagement/searchdropdown'
                label='انتخاب مشتری'
                name='customer'
                handelValue={handelValue}
              />
            </Col>
          </Row>
          <section style={{ backgroundColor: 'white', padding: '20px' }}>
            <Row>
              <Col>
                <nav class='nav nav-pills' role='tablist'>
                  <a
                    id='noanim-tab-example-tab-home'
                    href='#'
                    role='tab'
                    data-rb-event-key='home'
                    aria-controls='noanim-tab-example-tabpane-home'
                    aria-selected='false'
                    className={
                      navitem === 'اطلاعات شخصی'
                        ? 'nav-item nav-link active'
                        : 'nav-item nav-link'
                    }
                    tabindex='-1'
                    onClick={() => {
                      handelnavLink('اطلاعات شخصی');
                      sessionStorage.setItem('serch', JSON.stringify(''));
                    }}
                  >
                    اطلاعات شخصی
                  </a>
                  <a
                    id='noanim-tab-example-tab-finance'
                    href='#'
                    role='tab'
                    data-rb-event-key='finance'
                    aria-controls='noanim-tab-example-tabpane-finance'
                    aria-selected='false'
                    className={
                      navitem === 'امور مالی'
                        ? 'nav-item nav-link active'
                        : 'nav-item nav-link'
                    }
                    tabindex='-1'
                    onClick={() => {
                      handelnavLink('امور مالی');
                      sessionStorage.setItem('serch', JSON.stringify(''));
                    }}
                  >
                    امور مالی
                  </a>
                  <a
                    id='noanim-tab-example-tab-order'
                    href='#'
                    role='tab'
                    data-rb-event-key='order'
                    aria-controls='noanim-tab-example-tabpane-order'
                    aria-selected='true'
                    className={
                      navitem === 'سفارشات'
                        ? 'nav-item nav-link active'
                        : 'nav-item nav-link'
                    }
                    onClick={() => {
                      handelnavLink('سفارشات');
                      sessionStorage.setItem('serch', JSON.stringify(''));
                    }}
                  >
                    سفارشات
                  </a>
                  <a
                    id='noanim-tab-example-tab-blacklist'
                    href='#'
                    role='tab'
                    data-rb-event-key='blacklist'
                    aria-controls='noanim-tab-example-tabpane-blacklist'
                    aria-selected='true'
                    className={
                      navitem === 'نیروهای لیست سیاه'
                        ? 'nav-item nav-link active'
                        : 'nav-item nav-link'
                    }
                    onClick={() => handelnavLink('نیروهای لیست سیاه')}
                  >
                    نیروهای لیست سیاه
                  </a>
                  <a
                    id='noanim-tab-example-tab-favoriteList'
                    href='#'
                    role='tab'
                    data-rb-event-key='favoritelist'
                    aria-controls='noanim-tab-example-tabpane-favoritelist'
                    aria-selected='true'
                    className={
                      navitem === 'نیروهای مورد علاقه'
                        ? 'nav-item nav-link active'
                        : 'nav-item nav-link'
                    }
                    onClick={() => handelnavLink('نیروهای مورد علاقه')}
                  >
                    نیروهای مورد علاقه
                  </a>
                  <a
                    id='noanim-tab-example-tab-jobDispatch'
                    href='#'
                    role='tab'
                    data-rb-event-key='jobDispatch'
                    aria-controls='noanim-tab-example-tabpane-jobDispatch'
                    aria-selected='true'
                    className={
                      navitem === 'سفارشات پخش کار خودکار'
                        ? 'nav-item nav-link active'
                        : 'nav-item nav-link'
                    }
                    onClick={() => {
                      handelnavLink('سفارشات پخش کار خودکار');
                      sessionStorage.setItem('serch', JSON.stringify(''));
                    }}
                  >
                    سفارشات پخش کار خودکار
                  </a>
                  <a
                    id='noanim-tab-example-tab-canceledOrders'
                    href='#'
                    role='tab'
                    data-rb-event-key='canceledOrders'
                    aria-controls='noanim-tab-example-tabpane-canceledOrders'
                    aria-selected='true'
                    className={
                      navitem === 'سفارشات لغو شده'
                        ? 'nav-item nav-link active'
                        : 'nav-item nav-link'
                    }
                    onClick={() => {
                      handelnavLink('سفارشات لغو شده');
                      sessionStorage.setItem('serch', JSON.stringify(''));
                    }}
                  >
                    سفارشات لغو شده
                  </a>
                  <a
                    id='noanim-tab-example-tab-survey'
                    href='#'
                    role='tab'
                    data-rb-event-key='survey'
                    aria-controls='noanim-tab-example-tabpane-survey'
                    aria-selected='true'
                    className={
                      navitem === 'نظرسنجی'
                        ? 'nav-item nav-link active'
                        : 'nav-item nav-link'
                    }
                    onClick={() => {
                      handelnavLink('نظرسنجی');
                      sessionStorage.setItem('serch', JSON.stringify(''));
                    }}
                  >
                    نظرسنجی
                  </a>
                  <a
                    id='noanim-tab-example-tab-messages'
                    href='#'
                    role='tab'
                    data-rb-event-key='messages'
                    aria-controls='noanim-tab-example-tabpane-messages'
                    aria-selected='true'
                    className={
                      navitem === 'پیام‌ها'
                        ? 'nav-item nav-link active'
                        : 'nav-item nav-link'
                    }
                    onClick={() => {
                      handelnavLink('پیام‌ها');
                      sessionStorage.setItem('serch', JSON.stringify(''));
                    }}
                  >
                    پیام‌ها
                  </a>
                  <a
                    id='noanim-tab-example-tab-intro'
                    href='#'
                    role='tab'
                    data-rb-event-key='intro'
                    aria-controls='noanim-tab-example-tabpane-intro'
                    aria-selected='true'
                    className={
                      navitem === 'معرف‌ها'
                        ? 'nav-item nav-link active'
                        : 'nav-item nav-link'
                    }
                    onClick={() => {
                      handelnavLink('معرف‌ها');
                      sessionStorage.setItem('serch', JSON.stringify(''));
                    }}
                  >
                    معرف‌ها
                  </a>
                </nav>

                <div class='tab-content'>
                  <div
                    variant='success'
                    id='noanim-tab-example-tabpane-home'
                    aria-labelledby='noanim-tab-example-tab-home'
                    role='tabpanel'
                    aria-hidden='false'
                    className={
                      navitem === 'اطلاعات شخصی'
                        ? 'tab-pane active'
                        : 'tab-pane'
                    }
                  >
                    {navitem === 'اطلاعات شخصی' ? (
                      SohwaddFrom ? (
                        <>
                          <Button
                            onClick={handelCloseEdit}
                            variant='danger'
                            className='mb-2'
                          >
                            لغو ویرایش
                          </Button>
                          <FormUser urlWebsilte='/UserManagement' info={dataFech} />
                        </>
                      ) : (
                        <div>
                          <Row>
                            <Col lg='12' md='12' sm='12' xs='12'>
                              <div
                                style={{
                                  border: '1px solid #e9e9e9',
                                  borderRadius: '10px',
                                }}
                              >
                                <div className='d-flex justify-content-between'>
                                  <div className='d-flex'>
                                    <img
                                      src={
                                        dataFech?.imageUrl
                                          ? dataFech?.imageUrl
                                          : 'https://via.placeholder.com/100x100'
                                      }
                                      alt={dataFech?.fullName}
                                      width='100'
                                      height='100'
                                      className='imge_Profile lazy'
                                      loading='lazy'
                                    />
                                    <div className='mt-3 mr-4'>
                                      <p className='text-nowrap'>
                                        {dataFech?.genderTitle}{' '}
                                        {dataFech?.fullName}
                                      </p>
                                      <p className='text-nowrap'>
                                        <i
                                          style={{ fontSize: '18px' }}
                                          className='mdi mdi-cellphone-basic ml-2'
                                        ></i>
                                        {dataFech?.cellPhone}
                                      </p>
                                    </div>
                                  </div>
                                  <div className='ml-3'>
                                    <button
                                      style={{ height: '35px', marginLeft: 15 }}
                                      onClick={() =>
                                        handlechangeUserMobile(match.params.id)
                                      }
                                      className=' mr-auto mt-5 btn btn-sm btn-outline-warning btn-fw'
                                    >
                                      تغییر موبایل
                                    </button>
                                    <button
                                      style={{ height: '35px' }}
                                      onClick={() =>
                                        handelEditbtn(match.params.id)
                                      }
                                      className=' mr-auto mt-5 btn btn-sm btn-outline-warning btn-fw'
                                    >
                                      ویرایش
                                    </button>
                                  </div>
                                </div>

                                <Table
                                  hover
                                  className='tabele_Worker-profile_info'
                                >
                                  <tbody>
                                    <tr>
                                      <td className='text-nowrap'>
                                        تعداد سفارشات
                                      </td>
                                      <td>{dataFech?.orderNumber}</td>
                                    </tr>
                                    <tr>
                                      <td className='text-nowrap'>
                                        مبلغ کیف پول
                                      </td>
                                      <td>
                                        {new Intl.NumberFormat('ja-JP', {
                                          maximumSignificantDigits: 12,
                                        }).format(dataFech?.walletBalance)}{' '}
                                        ريال
                                      </td>
                                    </tr>
                                    <tr>
                                      <td className='text-nowrap'>توضیحات</td>
                                      <td>{dataFech?.description}</td>
                                    </tr>
                                  </tbody>
                                </Table>
                              </div>
                            </Col>
                          </Row>
                          <Row>
                            <Col
                              lg='12'
                              md='12'
                              sm='12'
                              xs='12'
                              className='mt-4'
                            >
                              <Accordion>
                                <Card>
                                  <Accordion.Toggle
                                    as={Card.Header}
                                    eventKey='0'
                                    onClick={() => handelAccordion(0)}
                                  >
                                    آدرس ها
                                  </Accordion.Toggle>
                                  <Accordion.Collapse eventKey='0'>
                                    <Card.Body>
                                      {idAccordion === 0 ? (
                                        <AddresCoustoumer
                                          id={match.params.id}
                                        />
                                      ) : null}
                                    </Card.Body>
                                  </Accordion.Collapse>
                                </Card>
                              </Accordion>
                            </Col>
                          </Row>
                        </div>
                      )
                    ) : null}
                  </div>
                  <div
                    variant='success'
                    id='noanim-tab-example-tabpane-finance'
                    aria-labelledby='noanim-tab-example-tab-finance'
                    role='tabpanel'
                    aria-hidden='true'
                    className={
                      navitem === 'امور مالی' ? 'tab-pane active' : 'tab-pane'
                    }
                  >
                    {sessionStorage.getItem('customerid') ? (
                      <FinanceCustomer customerid={match.params.id} />
                    ) : null}
                  </div>
                  <div
                    variant='success'
                    id='noanim-tab-example-tabpane-order'
                    aria-labelledby='noanim-tab-example-tab-order'
                    role='tabpanel'
                    aria-hidden='true'
                    className={
                      navitem === 'سفارشات' ? 'tab-pane active' : 'tab-pane'
                    }
                  >
                    {sessionStorage.getItem('customerid') ? (
                      <OrderCustomer />
                    ) : null}
                  </div>

                  <div
                    variant='success'
                    id='noanim-tab-example-tabpane-blackList'
                    aria-labelledby='noanim-tab-example-tab-blackList'
                    role='tabpanel'
                    aria-hidden='true'
                    className={
                      navitem === 'نیروهای لیست سیاه'
                        ? 'tab-pane active'
                        : 'tab-pane'
                    }
                  >
                    {sessionStorage.getItem('customerid') ? (
                      <BlacklistCustomer />
                    ) : null}
                  </div>

                  <div
                    variant='success'
                    id='noanim-tab-example-tabpane-favoriteList'
                    aria-labelledby='noanim-tab-example-tab-favoriteList'
                    role='tabpanel'
                    aria-hidden='true'
                    className={
                      navitem === 'نیروهای مورد علاقه'
                        ? 'tab-pane active'
                        : 'tab-pane'
                    }
                  >
                    {sessionStorage.getItem('customerid') ? (
                      navitem === 'نیروهای مورد علاقه' ? (
                        <FavoritelistCustomer />
                      ) : null
                    ) : null}
                  </div>

                  <div
                    variant='success'
                    id='noanim-tab-example-tabpane-jobDispatch'
                    aria-labelledby='noanim-tab-example-tab-jobDispatch'
                    role='tabpanel'
                    aria-hidden='true'
                    className={
                      navitem === 'سفارشات پخش کار خودکار'
                        ? 'tab-pane active'
                        : 'tab-pane'
                    }
                  >
                    {sessionStorage.getItem('customerid') ? (
                      <JobDispatchCustomer />
                    ) : null}
                  </div>

                  <div
                    variant='success'
                    id='noanim-tab-example-tabpane-canceledOrders'
                    aria-labelledby='noanim-tab-example-tab-canceledOrders'
                    role='tabpanel'
                    aria-hidden='true'
                    className={
                      navitem === 'سفارشات لغو شده'
                        ? 'tab-pane active'
                        : 'tab-pane'
                    }
                  >
                    {sessionStorage.getItem('customerid') ? (
                      <CanceledOrders />
                    ) : null}
                  </div>
                  <div
                    variant='success'
                    id='noanim-tab-example-tabpane-message'
                    aria-labelledby='noanim-tab-example-tab-message'
                    role='tabpanel'
                    aria-hidden='true'
                    className={
                      navitem === 'پیام‌ها' ? 'tab-pane active' : 'tab-pane'
                    }
                  >
                    {sessionStorage.getItem('customerid') ? (
                      navitem === 'پیام‌ها' ? (
                        <WorkerMessages id={dataFech?.code} isCustomer />
                      ) : null
                    ) : null}
                  </div>
                  <div
                    variant='success'
                    id='noanim-tab-example-tabpane-intro'
                    aria-labelledby='noanim-tab-example-tab-intro'
                    role='tabpanel'
                    aria-hidden='true'
                    className={
                      navitem === 'معرف‌ها' ? 'tab-pane active' : 'tab-pane'
                    }
                  >
                    {sessionStorage.getItem('customerid') ? (
                      navitem === 'معرف‌ها' ? (
                        <Introducers isCustomer />
                      ) : null
                    ) : null}
                  </div>
                </div>
              </Col>
            </Row>
          </section>
        </Layout>
      ) : (
        <Redirect to={{ pathname: '/login', state: { status: 302 } }} />
      )}
    </>
  );
}
